import { postRequest } from "./postRequest";
import type { ApiResponse } from "./order";

export type AdresSiparisDto = {
  adresId: number;
  baslik?: string | null;
  adSoyad?: string | null;
  telefon?: string | null;
  sehir?: string | null;
  ilce?: string | null;
  adresText?: string | null;
  varsayilanTeslimatMi: boolean;
  varsayilanFaturaMi: boolean;
};

export type AdresDetailDto = {
  adresId: number;
  musteriId: number;
  baslik?: string | null;
  adSoyad?: string | null;
  telefon?: string | null;
  ulke?: string | null;
  sehir?: string | null;
  ilce?: string | null;
  postaKodu?: string | null;
  adresSatiri1?: string | null;
  adresSatiri2?: string | null;
  vergiDairesi?: string | null;
  vergiNo?: string | null;
  varsayilanFaturaMi: boolean;
  varsayilanTeslimatMi: boolean;
  olusturmaTarihi: string;
  guncellemeTarihi?: string | null;
};

export const addressApi = {
  // Sipariş akışında minimal liste
  listForOrder: (musteriId: number) =>
    postRequest<{ musteriId: number }, ApiResponse<AdresSiparisDto[]>>(
      "/Adresler/siparis-liste",
      { musteriId }
    ),

  // Detay (seçili adresi JSON’a basmak için)
  detail: (musteriId: number, adresId: number) =>
    postRequest<{ musteriId: number; adresId: number }, ApiResponse<AdresDetailDto>>(
      "/Adresler/detay",
      { musteriId, adresId }
    ),
};
